import type { SerializedStyles } from "@emotion/react";
import type { ReactNode } from "react";

import { Typography, NoStyleAccordion } from "@aviary";
import type { AviarySize } from "@aviary/types";

type AccordionAviarySize = Extract<AviarySize, "xsmall" | "medium">;

interface Props {
  title: String;
  children: ReactNode;
  size?: AccordionAviarySize;
  triggerStyles?: SerializedStyles;
  onClick?: (open: boolean) => void;
}

const SidebarMenu = ({ title, triggerStyles, children, onClick, size = "medium" }: Props) => {
  return (
    <NoStyleAccordion
      size={size}
      onChange={onClick}
      triggerStyles={triggerStyles}
      coreTriggerContent={<Typography type="h5">{title}</Typography>}
    >
      {children}
    </NoStyleAccordion>
  );
};

export { SidebarMenu };
